import React from "react";
import {css} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {calculateRemSize, flexAbsoluteCenter, p} from "@pg-design/helpers-css";
import {IIcon} from "@pg-design/icons-module";

interface IProps {
    icon: React.ComponentType<IIcon>;
    iconSize: "1.2" | "2";
    onClick?: () => void;
    className?: string;
}

export const ReelDetailsControlButton = (props: IProps) => {
    const Icon = props.icon;

    const handleOnClick = () => {
        props.onClick?.();
    };

    return (
        <Button type="button" variant="none_secondary" onClick={handleOnClick} css={[buttonStyle]} className={props.className}>
            <Icon size={props.iconSize} css={iconStyle} />
        </Button>
    );
};

const buttonStyle = css`
    flex: 0 0 auto;
    ${p(0)};
    ${flexAbsoluteCenter};
    background-color: #fff;
    border-color: #fff;
    min-width: auto;
    min-height: auto;
    width: ${calculateRemSize(3)};
    height: ${calculateRemSize(3)};
`;

const iconStyle = css`
    user-select: none;
    pointer-events: none;
`;
import React from "react";
import {css} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {calculateRemSize, flexAbsoluteCenter, p} from "@pg-design/helpers-css";
import {IIcon} from "@pg-design/icons-module";

interface IProps {
    icon: React.ComponentType<IIcon>;
    iconSize: "1.2" | "2";
    onClick?: () => void;
    className?: string;
}

export const ReelDetailsControlButton = (props: IProps) => {
    const Icon = props.icon;

    const handleOnClick = () => {
        props.onClick?.();
    };

    return (
        <Button type="button" variant="none_secondary" onClick={handleOnClick} css={[buttonStyle]} className={props.className}>
            <Icon size={props.iconSize} css={iconStyle} />
        </Button>
    );
};

const buttonStyle = css`
    flex: 0 0 auto;
    ${p(0)};
    ${flexAbsoluteCenter};
    background-color: #fff;
    border-color: #fff;
    min-width: auto;
    min-height: auto;
    width: ${calculateRemSize(3)};
    height: ${calculateRemSize(3)};
`;

const iconStyle = css`
    user-select: none;
    pointer-events: none;
`;
